import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuditLandingComponent } from './audit-landing/audit-landing.component';
import { AuditReviewModalComponent } from './audit-review-modal/audit-review-modal.component';

const routes: Routes = [
  { path: 'audit', component: AuditLandingComponent },
];

@NgModule({
  declarations: [
    AuditLandingComponent,
    AuditReviewModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild(routes),
  ],
})
export class AuditModule {}
